// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2IA0z","row":"Node_row__Z4tLh","label":"Node_label__3zNxC","footer":"Node_footer__YZbEM"};